export const getListWithADotAtBeginningOfEachElement = (currentList) => {
  if (!Array.isArray(currentList) || !currentList.length) {
    return [];
  }
  const listWithADotAtBeginningOfEachElement = currentList.map((listElement) => `.${listElement}`);
  return listWithADotAtBeginningOfEachElement;
};
